module.exports = __webpack_public_path__ + "static/media/bottle.db8d4dc2.svg";